import { useCallback } from "react"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

import dayjs from "dayjs"

import { sendBookingRequestDecision, sendRequestDecision } from "api"
import { useAppDispatch } from "lib/hooks"
import { ReassignRequestConversation } from "reducers/conversations/conversations.reducer"
import { setConversation, setPendingErrand } from "reducers/selected"

export const useRequestDecision = () => {
  const dispatch = useAppDispatch()
  const intl = useIntl()
  const navigate = useNavigate()

  const handleRequestDecision = useCallback(
    (conversation: ReassignRequestConversation, approved: boolean, showToast = false) => {
      const bookingId = conversation.metadata?.bookingId

      if (conversation.state === "booked" && bookingId) {
        const isFuture = dayjs(conversation.bookingStart).isAfter(dayjs().endOf("day"))
        const text = isFuture ? "label.reassign.success_booked_appointment" : "label.reassign.success"

        dispatch(
          sendBookingRequestDecision(bookingId, approved, {
            showToast,
            text: showToast ? intl.formatMessage({ id: text }) : ""
          })
        )
      } else {
        dispatch(
          sendRequestDecision(conversation.id, approved, {
            showToast,
            text: showToast ? intl.formatMessage({ id: "label.reassign.success" }) : ""
          })
        )
      }

      if (approved) {
        // Accept: Use same logic as overview page - set conversation and navigate immediately
        dispatch(setConversation(conversation.id))
        dispatch(setPendingErrand(conversation.id))
        navigate("/")
      } else {
        // Decline: Navigate to overview page
        navigate("/overview")
      }
    },
    [dispatch, intl, navigate]
  )

  return { handleRequestDecision }
}
